import {PolarisMigrationState, PolarisRepositoryState, PolarisTransientIndex} from './polaris-state.models';

export const DEFAULT_POLARIS_PAGINATION = {
  limit: 50,
  offset: 0,
  total: 0
} as const;

export const DEFAULT_POLARIS_MIGRATION: PolarisMigrationState = {
  isRunning: false,
  isCompleted: false,
  lastRunAt: null,
  attempts: 0,
  lastError: null
};

export const DEFAULT_POLARIS_TRANSIENT_INDEX: PolarisTransientIndex = {
  requestToPendingMessageId: {},
  interactionToRequestId: {}
};

export const createInitialPolarisState = (): PolarisRepositoryState => ({
  accountKey: null,
  chatsById: {},
  hydratedChatIds: {},
  chatOrder: [],
  activeChatId: null,
  recentChatId: null,
  recentChatIdTimeout: null,
  pagination: {...DEFAULT_POLARIS_PAGINATION},
  loading: {
    overview: false,
    activeChat: false,
    sendMessage: false,
    migration: false
  },
  errors: {
    overview: null,
    activeChat: null,
    sendMessage: null,
    migration: null
  },
  migration: {...DEFAULT_POLARIS_MIGRATION}
});
